







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class ReviewListIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PREMIUM', activeTab: query?.activeTab?.toString() ?? 'list' };
    const queryString = new URLSearchParams(queryObject).toString();
    const {activeTab} = queryObject;
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + `/board/management/product-review/${activeTab}?` + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
